import React, { FC } from "react";

export type LightboxImageType = {
  image: string;
  caption: string;
};

const getImageData = (image: string, caption: string) => ({
  items: [
    {
      url: `${image}`,
      caption: `${caption}`,
    },
  ],
});

// classname w-json required inside a script tag

export const LightboxImage: FC<LightboxImageType> = ({
  image,
  caption,
}: LightboxImageType) => (
  <script
    className="w-json"
    dangerouslySetInnerHTML={{
      __html: JSON.stringify(getImageData(image, caption)),
    }}
  />
);
